module.exports = __webpack_public_path__ + "static/img/2.1267f6d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/5/1/sp/2.png
// module id = 5l7I
// module chunks = 0